import { NSLinkBlue } from '../components/NSLinkBlue';
import Styles from './NSNotFoundPage.module.css'

export function NSNotFoundPage()
{
	return (
		<div className="d-flex justify-content-center flex-column">
			<div className={Styles.ns_not_found_page}></div>
			<NSLinkBlue href='/' target='_self' title='Back To Home' />
		</div>
	);
}